<template>
  <FilterGroup title="Statut">
    <!-- <FilterButton
      label="Tout"
      :active="filter === null"
      @click.native="$emit('updateFilter', null)"
    /> -->
    <FilterButton
      label="En attente"
      icon="hourglass-half"
      color="yellow"
      :active="filter === 'waiting'"
      @click.native="$emit('updateFilter', 'waiting')"
    />
    <FilterButton
      label="Confirmé"
      icon="check"
      color="green"
      :active="filter === 'confirmed'"
      @click.native="$emit('updateFilter', 'confirmed')"
    />
  </FilterGroup>
</template>

<script>
import FilterButton from './FilterButton.vue';
import FilterGroup from './FilterGroup.vue';

export default {
  components: {
    FilterButton,
    FilterGroup,
  },

  props: ['filter'],
};
</script>
